exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (max-width:959px){html{overflow:hidden}body{height:100dvh;overflow-y:auto;-webkit-overflow-scrolling:touch}}", ""]);

